import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../Services/GlobalService";

const AllConstructRecors = () => {
  const [selectedType, setSelectedType] = useState("B2C");
  const [data, setData] = useState([]);

  // const data = [];

  const Controller = "ConstructDBSIP";
  const DbSipEndPoint = {
    GetStreamAndChannel: "GetStreamAndChannel",
  };

  const nav = useNavigate();

  /**
   * Navigate to the Construct page with:
   *  - constructid  → the Seq of the selected row
   *  - constructType → the radio-selected type (B2C / HDSSD / Industrial DB)
   * The Construct component reads these via useSearchParams and calls
   * /api/ConstructDBSIP/GetConstructDefById to pre-populate all form data.
   */

  useEffect(() => {
    const allrecordData = async () => {
      try {
        let allrecorddt = await fetchData(
          Controller,
          DbSipEndPoint.GetStreamAndChannel,
          `FLAG=1&CONSTRUCT_TYPE=${selectedType == "Industrial DB" ? "IND" : selectedType}&STREAM_CODE=${selectedType == "Industrial DB" ? "IND" : selectedType}`,
        );
        setData(allrecorddt.Data);
      } catch (error: any) {}
    };

    allrecordData();
  }, [selectedType]);

  const movetoConstruct = (item: any) => {
    nav(
      `/DBSIP/NewConstruct?constructid=${item.Seq}&constructType=${selectedType}`,
    );
  };

  const actionBodyTemplate = (item: any) => {
    return (
      <div className="action-icon">
        <button
          className="grid-icon-img"
          title="View/Edit"
          onClick={() => movetoConstruct(item)}
        >
          <img
            alt="InnoRise"
            src={require("../../../Assets/Images/ViewEdit.png")}
          />
        </button>
      </div>
    );
  };

  const movetoNew = () => {
    nav("/DBSIP/NewConstruct");
  };

  return (
    <main>
      <div className="col-12 mb-5">
          {/* Breadcrumb */}
          <div className="col-lg-12 col-md-12 col-sm-12">
            <nav aria-label="breadcrumb" className="drop-in">
              <ol className="breadcrumb mx-0">
                <li className="breadcrumb-item">DB SIP</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Construct
                </li>
              </ol>
            </nav>
          </div>
          
          <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h3 className="py-2">Construct</h3>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="d-flex flex-wrap justify-content-center align-content-center gap-3 mb-2">
                {["B2C", "HDSSD", "Industrial DB"].map((type) => (
                  <div key={type} className="field-radiobutton">
                    <RadioButton
                      inputId={type}
                      value={type}
                      onChange={(e) => setSelectedType(e.value)}
                      checked={selectedType === type}
                    />
                    <label htmlFor={type} className="mx-2">
                      {type}
                    </label>
                  </div>
                ))}
              </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="text-end mb-2">
              <button
                type="button"
                className="btn anime-btn"
                onClick={movetoNew}
              >
                Add New
              </button>
            </div>
          </div>
          </div>

        <section>
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="DataTable">
              <DataTable
                value={data}
                paginator
                rows={10}
                scrollable
                rowsPerPageOptions={[10, 25, 50]}
                scrollHeight="80vh"
                showGridlines
                stripedRows
                emptyMessage="No record found."
              >
                <Column field="Name" header="Name" />
                <Column field="StartDate" header="Start Date" />
                <Column body={actionBodyTemplate} header="Actions" />
              </DataTable>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default AllConstructRecors;
